module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAWCAYAAADAQbwGAAAAY0lEQVQ4jWN89Oz1fwYqAiZqGjbMDEzPq6eugW/ffaCugcSCEWggI3pOAcUmsREAAoKCfAyzJjUxMDIyYjcQFwiJyWdYs2QiQXWDPwyHkYHCQgJEqSM6lokFwygMiQUs1DYRAA/YHEmVqsJzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/xjtb1-2.png
// module id = 727
// module chunks = 0